import React, { Component } from 'react';
import { Route, Link, NavLink, BrowserRouter as Router } from 'react-router-dom'
export class MenuItem extends Component {

    countBadge = () => {
        if (this.props.countBadge === null) {
            return (
                <span></span>
            );
        } else {
            return (
                <span class="badge pull-right">{this.props.countBadge}</span>
            );
        }
    }


    renderItem = () => {
        let activeClass = "active";
        let itemClass = "";
        if (this.props.active !== null && this.props.active === "true") {
            activeClass = "active";
        } else {
            activeClass = "";
        }
        if (React.Children.count(this.props.children) === 0) {
            itemClass = activeClass;
            return (
                <li className={itemClass}>
                    <NavLink activeClassName='active' to={this.props.link} > 
                        {this.countBadge()}
                        <i  className={this.props.icon}></i>
                        <span>{this.props.text}</span>
                    </NavLink> 

                </li>
            )
        }
        else {
            itemClass = "has-sub " + activeClass;
            return (
                <li className={itemClass}>
                    <a href="javascript:;">
                        <b class="caret"></b>
                        {this.countBadge()}
                        <i className={this.props.icon}></i>
                        <span>{this.props.text}</span>
                    </a>
                    <ul class="sub-menu">
                        {this.props.children}
                    </ul>
                </li>
            )
        }

    }
    render() {
        return (this.renderItem());
    }
}
export class SubMenuItem extends Component {




    renderItem = () => {

        if (React.Children.count(this.props.children) === 0) {
            return (
                <li><NavLink to={this.props.link} > {this.props.text}</NavLink> </li>

            )
        }
        else {
            return (
                <li class="has-sub">
                    <a href="javascript:;"><b class="caret"></b>{this.props.text}</a>
                    <ul class="sub-menu">
                        {this.props.children}
                    </ul>
                </li>

            )
        }

    }
    render() {
        return (this.renderItem());
    }
}




// WEBPACK FOOTER //
// ./src/components/sidebar/SideBar_MenuItem.js